import {RootState} from '@/store'
import {Module} from 'vuex'
import {actions} from './actions'
import {getters} from './getters'
import {mutations} from './mutations'

export interface LoanConfiguration extends BaseState {
  loanConfig: LoanConfig,
  loan: Loan
}

export interface LoanConfig {
  maximumAmount: number,
  minimumAmount: number,

  activeService: boolean

  accountSeniorityCheck: boolean

  sundayActive: boolean
  mondayActive: boolean
  tuesdayActive: boolean
  wednesdayActive: boolean
  thursdayActive: boolean
  fridayActive: boolean
  saturdayActive: boolean
}

export interface Loan {
  activeFundFlags: ActiveFundFlag[],
  yearOptions: YearOptions[],
  percentLiquidAmount: number
  percentIlliquidAmount: number
}

export interface ActiveFundFlag {
  id: string,
  checked: boolean,
  fundName: string
  fundNumber: number
}

export interface YearOptions {
  loanType: string,
  loanTypeValue: number,
  interest1YearsToExpiration: string,
  interest2YearsToExpiration: string,
  interest3YearsToExpiration: string,
  interest4YearsToExpiration: string,
  interest5YearsToExpiration: string,
  interest6YearsToExpiration: string,
  interest7YearsToExpiration: string,
  rating: string,
  ratingValue: number
}

export const initialState = function (): LoanConfiguration {
  return {
    loanConfig: {
      maximumAmount: 0,
      minimumAmount: 0,
      accountSeniorityCheck: false,
      activeService: false,
      sundayActive: false,
      mondayActive: false,
      tuesdayActive: false,
      wednesdayActive: false,
      thursdayActive: false,
      fridayActive: false,
      saturdayActive: false,
    },
    loan: {
      activeFundFlags: [],
      yearOptions: [],
      percentLiquidAmount: 0,
      percentIlliquidAmount: 0,
    },
    isEmpty: true
  }
}

export const loanConfiguration: Module<LoanConfiguration, RootState> = {
  namespaced: true,
  state: initialState(),
  getters,
  actions,
  mutations
}
